import apiService from '../../apiService';

const CATEGORY_URL = 'setup/expense/categories';
const categoryService = {
  
    async createCategory(payload) {
        try {
            const response = await apiService.post(`/${CATEGORY_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllCategory(params = {}) {
        try {
            const queryParams = new URLSearchParams(params).toString();
            const response = await apiService.get(`/${CATEGORY_URL}${queryParams ? `?${queryParams}` : ''}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getSingleCategory(id) {
        try {
            const response = await apiService.get(`/${CATEGORY_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateCategory(payload, id) {
        try {
            const response = await apiService.put(`/${CATEGORY_URL}/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteCategory(id) {
        try {
            const response = await apiService.delete(`/${CATEGORY_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default categoryService;